/**
 * aiConsentApi — thin wrapper around the /api/consent/ai endpoints.
 *
 * Kept in its own file (rather than folded into userApi.js) so the AI
 * Consent surface can be lint-owned and regression-tested in isolation.
 * All three verbs share the same shape and are called from exactly two
 * places: the AIConsentProvider (context) and the Settings toggle.
 */
import { userApi } from "./userApi";

// GET — { granted, version, stored_version, granted_at, withdrawn_at, ... }
// The frontend prompts the user whenever `granted === false`, regardless
// of whether that's because it was never granted or was withdrawn.
export const getAIConsent = () =>
  userApi.get("/consent/ai").then((r) => r.data);

export const grantAIConsent = () =>
  userApi.post("/consent/ai").then((r) => r.data);

export const withdrawAIConsent = () =>
  userApi.delete("/consent/ai").then((r) => r.data);
